var map = {
	"./accesibilidad.svg": "./src/assets/iconos/accesibilidad.svg",
	"./amenazas.svg": "./src/assets/iconos/amenazas.svg",
	"./analisis_agua.svg": "./src/assets/iconos/analisis_agua.svg",
	"./aves.svg": "./src/assets/iconos/aves.svg",
	"./biodiversidad.svg": "./src/assets/iconos/biodiversidad.svg",
	"./fauna.svg": "./src/assets/iconos/fauna.svg",
	"./gorrion.svg": "./src/assets/iconos/gorrion.svg",
	"./impacto.svg": "./src/assets/iconos/impacto.svg",
	"./interpretation_sensorial.svg": "./src/assets/iconos/interpretation_sensorial.svg",
	"./mapa.svg": "./src/assets/iconos/mapa.svg",
	"./mareas.svg": "./src/assets/iconos/mareas.svg",
	"./meteorologia.svg": "./src/assets/iconos/meteorologia.svg",
	"./oido.svg": "./src/assets/iconos/oido.svg",
	"./olfato.svg": "./src/assets/iconos/olfato.svg",
	"./residuos.svg": "./src/assets/iconos/residuos.svg",
	"./rio.svg": "./src/assets/iconos/rio.svg",
	"./servicios_eco.svg": "./src/assets/iconos/servicios_eco.svg",
	"./ubicacion.svg": "./src/assets/iconos/ubicacion.svg",
	"./valoracion1.svg": "./src/assets/iconos/valoracion1.svg",
	"./valoracion2.svg": "./src/assets/iconos/valoracion2.svg",
	"./valoracion3.svg": "./src/assets/iconos/valoracion3.svg",
	"./valoracion4.svg": "./src/assets/iconos/valoracion4.svg",
	"./valoracion5.svg": "./src/assets/iconos/valoracion5.svg",
	"./vegetacion.svg": "./src/assets/iconos/vegetacion.svg",
	"./vista.svg": "./src/assets/iconos/vista.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/iconos sync recursive ^\\.\\/.*$";